import FR from "@/lib/fr.json";

const exact = new Map(Object.entries(FR.exact));
const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const patterns = FR.patterns.map(([en, fr]) => [new RegExp("^" + esc(en).replace(/\\\{(\d)\\\}/g, "(.+?)") + "$"), fr]);
const ATTRS = ["placeholder", "title", "aria-label"];
const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "NOSCRIPT"]);
const orig = new WeakMap();
const set = new WeakMap();
const attrOrig = new WeakMap();
let active = false;
let observer = null;

function tr(s) {
  const t = s.trim();
  if (!t || !/[A-Za-z]/.test(t)) return null;
  let r = exact.get(t);
  if (r == null) {
    for (const [re, fr] of patterns) {
      const m = t.match(re);
      if (m) { r = fr.replace(/\{(\d)\}/g, (_, i) => tr(m[+i + 1]) ?? m[+i + 1]); break; }
    }
  }
  return r == null ? null : s.replace(t, r);
}

function skip(node) {
  const el = node.nodeType === 1 ? node : node.parentElement;
  if (el && el.tagName === "TITLE") return false;
  return !el || SKIP.has(el.tagName) || el.closest("[data-no-translate]");
}

function doText(n) {
  if (skip(n) || n.nodeValue === set.get(n)) return;
  const t = tr(n.nodeValue);
  if (t != null && t !== n.nodeValue) {
    orig.set(n, n.nodeValue);
    set.set(n, t);
    n.nodeValue = t;
  }
}

function doAttrs(el) {
  if (SKIP.has(el.tagName) && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA") return;
  for (const a of ATTRS) {
    const v = el.getAttribute(a);
    if (!v) continue;
    const t = tr(v);
    if (t != null && t !== v) {
      const o = attrOrig.get(el) || {};
      o[a] = v;
      attrOrig.set(el, o);
      el.setAttribute(a, t);
    }
  }
}

function walk(root) {
  if (root.nodeType === 3) return doText(root);
  if (root.nodeType !== 1) return;
  doAttrs(root);
  const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let n;
  while ((n = it.nextNode())) n.nodeType === 3 ? doText(n) : doAttrs(n);
}

function restore() {
  const it = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let n;
  const tn = document.querySelector("title")?.firstChild;
  if (tn && orig.has(tn) && tn.nodeValue === set.get(tn)) tn.nodeValue = orig.get(tn);
  while ((n = it.nextNode())) {
    if (n.nodeType === 3 && orig.has(n) && n.nodeValue === set.get(n)) n.nodeValue = orig.get(n);
    if (n.nodeType === 1 && attrOrig.has(n)) for (const [a, v] of Object.entries(attrOrig.get(n))) n.setAttribute(a, v);
  }
}

export function setAutoTranslate(lang) {
  const on = lang === "fr";
  if (on === active) return;
  active = on;
  if (on) {
    walk(document.body);
    observer = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "characterData") doText(m.target);
        else if (m.type === "attributes") doAttrs(m.target);
        else m.addedNodes.forEach(walk);
      }
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS });
    const title = document.querySelector("title");
    if (title) { walk(title.firstChild || title); observer.observe(title, { subtree: true, childList: true, characterData: true }); }
  } else {
    observer?.disconnect();
    restore();
  }
}
